import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-new-ride',
    templateUrl: './new-ride.component.html',
    imports: [RouterModule],
    standalone: true
})
export class NewRideComponent {
    
}